<script>
	import { cn } from "./cn.js";

	export let variant = "default"; // default | secondary | outline | ghost | destructive
	export let size = "default"; // default | sm | lg | icon
	export let type = "button";
	let className = "";
	export { className as class };

	const base =
		"tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-md tw-text-sm tw-font-medium tw-transition-colors tw-cursor-pointer focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50";

	const variants = {
		default: "tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/90",
		secondary: "tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80",
		outline:
			"tw-border tw-border-input tw-bg-background tw-text-foreground hover:tw-bg-accent hover:tw-text-accent-foreground",
		ghost: "tw-text-foreground hover:tw-bg-accent hover:tw-text-accent-foreground",
		destructive: "tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/90",
	};

	const sizes = {
		default: "tw-h-10 tw-px-4 tw-py-2",
		sm: "tw-h-9 tw-px-3",
		lg: "tw-h-11 tw-px-6 tw-text-base",
		icon: "tw-h-10 tw-w-10",
	};
</script>

<button
	{type}
	class={cn(base, variants[variant], sizes[size], className)}
	on:click
	{...$$restProps}
>
	<slot />
</button>
